import React, { useState, useEffect } from 'react';
import {
	MDBModal,
	MDBRow,
	MDBModalBody,
	MDBModalHeader,
	MDBInput,
	MDBModalFooter
} from 'mdbreact';
import Select from 'react-select';


import Card from '../../../Card/Card';

import { BiSolidAddToQueue } from "react-icons/bi";
import { CiEdit } from "react-icons/ci";
import { Button, InputLabel } from '@mui/material'
import GridItem from '../../../Grid/GridItem';
import GridContainer from '../../../Grid/GridContainer';
import NativeSelect from '@mui/material/NativeSelect';

import { useAuthDataContext } from '../../../../services/auth/AuthContext';

import { GetAll } from '../../../GetAll';

import ConsultoresService from '../../../../services/consultores/consultores';

import Masks from "../../../Masks/Masks";

const customStyles = {
	control: (provided, state) => ({
		...provided,
		color: 'black',
		backgroundColor: 'white',
		marginTop: '5px',
		minHeight: '38px',
	}),
	menu: (provided, state) => ({
		...provided,
		color: 'black',
		fontSize: '12px',
		fontWeight: '400',
		backgroundColor: '#fff',
		zIndex: 9999,
	}),
	option: (provided, state) => ({
		...provided,
		color: state.isSelected ? 'white' : 'black',
		backgroundColor: state.isSelected ? '#000' : '#fff',
		'&:hover': {
			backgroundColor: '#f1f1f1',
			fontSize: '12px',
			fontWeight: '400'
		},
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: '#B19B80',
		color: '#fff',
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: 'white',
		fontSize: '12px',
		fontWeight: '400'
	}),
	menuPortal: base => ({ ...base, zIndex: 9999999 })
};

export default function ModalAddConsultorPedido(props) {
	// Dados retornados para o pedido
	const {
		listaConsultores,
		setListaConsultores,
		isUpdate,
		quantidade,
		setQuantidade,
		idConsultores
	} = props;


	const mask = new Masks()

	// Services
	const consultoresService = new ConsultoresService()
	// User
	const { user, userGroup, user_id } = useAuthDataContext()
	// Errors	, 
	const [error, setError] = useState('')

	// Variáveis de controle do Modal
	const [modal, setModal] = useState(false);
	const toggleConsultor = () => {
		setModal(!modal)
	}

	useEffect(() => {
		const consultoresFormat = listaConsultores.map(consultor => ({
			value: consultor.value,
			label: consultor.label,
			email: consultor.email,
			isFixed: consultor.isFixed || false,
			isSelected: true
		}));
		setSelectedOptions(consultoresFormat);
	}, [listaConsultores]);

	// Campos de clientes
	const [consultor, setConsultor] = useState('')
	const [consultores, setConsultores] = useState([])
	// Determina opcoes de consultores
	const showConsultores = consultores.map((data, idx) => {
		let isFixed = false

		/* 
		remover logica de fixar consultor padrao para orcamento
		if (userGroup == 'Orcamento') {
			if (idx == 0) {
				isFixed = true
			}

		} */
		return (
			{
				value: data.id,
				label: data.nome,
				email: data.email,
				isFixed: isFixed,
			}
		)
	})


	// Valida os campos antes de permitir o filtro
	const checkValues = () => {
		if (
			quantidade <= 0 ||
			listaConsultores.length != quantidade ||
			listaConsultores.length <= 0
		) {
			return true
		} else {
			return false
		}
	}

	const getConsultores = () => {

		if (user.is_superuser) {
			consultoresService.getAllActive()
				.then(response => {
					if (response.status === 200) {
						setConsultores(response.data)
					} else {
						error('Erro ao listar consultores ativos!!')
					}
				})
				.catch(error => {
					console.log(error)
					error(error)
				})
		}
		if (userGroup == 'Orcamento') {

			consultoresService.getConsultorByUser({ email: user.email, ativos_somente: true })
				.then(response => {
					if (response.status === 200) {

						const { default: defaultConsultor, others } = response.data;
						const filterOthers = others.filter(consultor => consultor.id !== defaultConsultor.id);
						setConsultores([defaultConsultor, ...filterOthers]);
						console.log(listaConsultores)
						if (listaConsultores.length > 0) {
							const consultoresFormat = listaConsultores.map(consultor => ({
								value: consultor.value,
								label: consultor.label,
								email: consultor.email,
								isFixed: false, // Removendo isFixed forçado
								isSelected: true
							}));
							setSelectedOptions(consultoresFormat);
						}
					} else {
						error('Erro ao listar consultor por usuário!!')
					}
				})
				.catch(error => {
					console.log(error)
					error(error)
				})

			console.log(listaConsultores)
		}

	}

	// Limpa os campos
	const clearState = () => {
		setConsultores([])
		setQuantidade('')
	}

	const [selectedOptions, setSelectedOptions] = React.useState([]);

	const handleChangeConsultor = (e, option) => {
		if (option.removedValue && option.removedValue.isFixed) return;
		setSelectedOptions(e);
		setListaConsultores(e);
	}
	return (
		<>
			<MDBModal
				isOpen={modal}
				toggle={toggleConsultor}
				size='lg'
				disableBackdrop
			>
				<MDBModalBody>
					<GridItem center
						className="title-subinfo"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'row',
							alignItems: 'center',
							backgroundColor: '#ADC5B4',
							color: 'white',
							fontSize: '22px',
							marginLeft: '0',
							marginRight: '0',
							fontWeight: '600',
							marginBottom: '10px',
							marginTop: '10px'
						}}>
						{userGroup == 'Orcamento' ? (
							<>
								Consultor do Orçamento
							</>
						) : (
							<>
								Consultor do Pedido
							</>
						)}

					</GridItem>
					<GridContainer>
						<GridItem className="grid-item" xs={12} sm={12} md={3} >
							<MDBInput
								label="Quantidade *"
								required
								type="number"
								min="1"
								step="1"
								error="wrong" success="right"
								value={quantidade}
								onChange={(e) => {
									setQuantidade(mask.number(e.target.value))
									getConsultores(mask.number(e.target.value))
								}}
							/>
						</GridItem>
						{consultores.length > 0 && quantidade != "" ? (


							<GridItem className="grid-item" xs={12} sm={12} md={9} >
								<InputLabel shrink style={{ color: '#000', marginBottom: '0px', marginTop: '13px' }}>
									Selecione o Consultor *
								</InputLabel>
								<Select
									isMulti
									styles={customStyles}
									value={selectedOptions}
									placeholder="Clique para selecionar..."
									menuPortalTarget={document.body}
									menuShouldScrollIntoView={false}
									onChange={(e, option) => {
										handleChangeConsultor(e, option)
									}}
									options={showConsultores}
									isOptionDisabled={() => selectedOptions.length >= quantidade}
									className="basic-multi-select"
									classNamePrefix="select"
								/>
							</GridItem>
						) : (null)}
					</GridContainer>
				</MDBModalBody>

				<MDBRow end style={{ marginRight: '0px' }}>
					<MDBModalFooter>
						<Button variant="contained" style={{ backgroundColor: 'orangered' }} onClick={toggleConsultor}>Cancelar</Button>
					</MDBModalFooter>

					<MDBModalFooter>
						<Button disabled={checkValues()} variant="contained"
							onClick={() => {
								toggleConsultor()
							}}
						>
							{isUpdate ? (
								<>
									Alterar
								</>
							) : (
								<>
									Adicionar
								</>
							)}
						</Button>
					</MDBModalFooter>
				</MDBRow>
			</MDBModal >


			{/* Botão para filtro */}
			{
				isUpdate || listaConsultores.length > 0 ? (
					<CiEdit
						title='Adicionar Consultor'
						className="btn-manage"
						onClick={() => {
							toggleConsultor()
							clearState()
						}}
						style={{ height: '24px', color: '#F6EDD2', width: '24px' }}
					/>
				) : (
					<BiSolidAddToQueue
						title='Adicionar Consultor'
						className="btn-manage"
						onClick={() => {
							clearState()
							toggleConsultor()

						}}
						style={{ height: '24px', color: '#F6EDD2', width: '24px' }}
					/>
				)
			}

		</>
	)
}